import { render, staticRenderFns } from "./BtnBase.vue?vue&type=template&id=0ff07266&scoped=true&lang=pug&"
import script from "./BtnBase.vue?vue&type=script&lang=ts&"
export * from "./BtnBase.vue?vue&type=script&lang=ts&"
import style0 from "./BtnBase.vue?vue&type=style&index=0&id=0ff07266&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff07266",
  null
  
)

export default component.exports